module.exports = __webpack_public_path__ + "fonts/icomoon.33c246a9.woff";